@if (deviceInfo$ | async; as deviceInfo) {
  @if (
    !isNativeApp() &&
    (deviceInfo.operatingSystem === 'android' || deviceInfo.operatingSystem === 'ios')
  ) {
    <parkour-info-card-with-title title="Problemen met aanmelden in de app?" class="block my-4">
      <p>
        Kies
        @if (deviceInfo.operatingSystem === 'ios') {
          Safari
        } @else {
          Chrome
        }
        als standaardbrowser op je toestel.
      </p>
      <a
        class="underline font-medium cursor-pointer"
        [routerLink]="['over', 'veelgestelde-vragen']"
        [queryParams]="{
          instructionReference: 'hulp-bij-aanmelden',
        }"
        >Hulp bij aanmelden</a
      >
    </parkour-info-card-with-title>
  }
}
